'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchHistory = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _buildError = require('conversations-infrastructure/errors/builders/buildError');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchHistory = exports.fetchHistory = function fetchHistory(channel) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new _q2.default.Promise(function (resolve, reject) {
    channel.history(options, function (historyError, resultPage) {
      if (historyError) {
        var error = (0, _buildError.buildError)('PubSub history error.  Reason: ' + historyError.message, historyError);
        reject(error);
      } else {
        resolve(resultPage.items);
      }
    });
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/fetchHistory.js
// module id = 405
// module chunks = 2 3